/**
 * HeaderAnchor
 * ======================================
 * - Close mobile menu when anchor link is clicked
 */

class HeaderAnchor {
  constructor() {
    this.nav = document.querySelector('.header-nav')

    if (!this.nav) {
      return
    }

    this.init()
  }

  init() {
    // Find all links in header-nav
    const links = this.nav.querySelectorAll('a[href*="#"]')

    links.forEach(link => {
      link.addEventListener('click', (e) => {
        const href = link.getAttribute('href')

        // Check if link contains anchor (#)
        if (href && href.includes('#')) {
          const [url, anchor] = href.split('#')

          const currentPath = window.location.pathname
          const linkPath = url ? new URL(url, window.location.origin).pathname : currentPath

          // If anchor exists and we're on the same page
          if (anchor && currentPath === linkPath) {
            // Close mobile menu
            this.closeMenu()
          }
        }
      })
    })
  }

  closeMenu() {
    document.body.classList.remove('nav-is-open')
  }
}

new HeaderAnchor()
